exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-block-overflow{width:100%;max-width:100%;overflow-x:auto}.month-card-size{min-width:240px;max-width:240px}.custom-select{line-height:21px;height:37px;border-radius:5px}.table-of-users tr td:first-child{width:60%;line-height:14px}.table-all-inline tr td{vertical-align:bottom;padding-bottom:0}.table-all-inline tr td:first-child{width:60%;text-align:right;line-height:12px;padding-bottom:5px;padding-right:5px}.table-all-inline tr td:last-child{text-align:left;font-size:.9rem}", ""]);

// exports
